'use strict';

angular.module('app.common')

.directive('signUpNewsLetterButton', ['ApiService','$routeParams', 'APP_CONFIG', '$document', '$timeout', function(apiService, $routeParams, APP_CONFIG, $document, $timeout) {
	function link(scope, elem, attrs) {

    scope.$watch("getLocalization()['modal.newsletter.btn.title']", function() {
      angular.element($document).foundation('equalizer', 'reflow');
    });

		scope.gaEventPagename = attrs.gaEventPagename + ' Page';
    $timeout(function() {
      angular.element($document).foundation('reveal');
    }, 0);

    scope.locationsData = [];
    if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
        apiService.getLocations($routeParams.langCode).then(function (response) {
                angular.forEach(response.data, function (data) {
                    if ($routeParams.locCode == APP_CONFIG.DEFAULT_HOME) {
                        scope.locationsData.push(data);
                    } else if ($routeParams.locCode == data.locationCode) {
                        scope.selectedLocation = data;
                    }
                });
            }, function (error) {
                console.log('error', error);
            }
        );
    }

    scope.isLocationClickable = function () {
      if ($routeParams.locCode === APP_CONFIG.DEFAULT_HOME) {
        return true;
      } else {
        return false;
      }
    };
    //mocked until BIServices did get translated
    var newsLetterMessage = new NewsLetterMessage('Souhaitez-vous recevoir notre bulletin?: (Yes) or (No)');

    scope.$watch("getLocalization()['modal.registerToNewsLetterBtn.message']", function() {
      if(scope.getLocalization()) {
        var message = scope.getLocalization()['modal.registerToNewsLetterBtn.message'];
        newsLetterMessage.setMessage(message);
      }
    });

    var newsLetterSubject = new NewsLetterSubject("");
    scope.$watch("getLocalization()['modal.registerToNewsLetterBtn.subject']", function() {
        if(scope.getLocalization()) {
            var message = scope.getLocalization()['modal.registerToNewsLetterBtn.subject'];
            newsLetterSubject.setSubject(message);
        }
    });


        scope.newsLetterSignUpSubmit = function(){

      var newsLetterSignUpInfo = Object.assign(scope.newsLetterSignUpForm, {
        message: newsLetterMessage.getMessage()
      });

      var contactEmail;
      scope.selectedLocation.contacts.forEach(function(value){
        if(value.contactType == "customersupport") {
          contactEmail = value.email;
        }
      });

      // for newsletter form - set receive newsletter to true always
      newsLetterSignUpInfo.news = true;
      newsLetterSignUpInfo.subject = newsLetterSubject.getSubject();

      apiService.sendContactUsEmail(contactEmail, newsLetterSignUpInfo).then(
        function(res) {
          scope.submittedResult = 2;
          resetForm();
        },
        function(err) {
          scope.submittedResult  = 1;
        }
      );

    }

    var resetForm = function () {
      for(var key in scope.newsLetterSignUpForm) { scope.newsLetterSignUpForm[key] = undefined }
    }

    function NewsLetterMessage  (message) {
		  this.message = message;
      this.getMessage = function() {
        return this.message;
      };
      this.setMessage = function (message) {
        this.message = message;
      };
    }
    function NewsLetterSubject (subject) {
		this.subject = subject;
		this.getSubject = function() {
		    return this.subject;
        };
        this.setSubject = function (subject) {
            this.subject = subject;
        };
    }

	}
	return {
		restrict: 'E',
		scope: true,
		templateUrl: 'app/common/directives/signupnewsletterbutton/signUpNewsLetterButtonDirective.html',
		link: link
	}
} ]);



// WEBPACK FOOTER //
// ./app/common/directives/signupnewsletterbutton/signUpNewsLetterButtonDirective.js